var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"10c182ef8fe2e46928075ac249687972ac8feee7"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const environment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? 'production';

// Only these environments send data to Sentry. Development and local builds
// were consuming the paid quota with noise.
const ENABLED_ENVIRONMENTS = ['production', 'staging'];

Sentry.init({
  dsn:
    process.env.NEXT_PUBLIC_SENTRY_DSN ??
    'https://e676fef00ea4497b8dc5339f5534800c@o1296209.ingest.us.sentry.io/6547782',

  enabled: ENABLED_ENVIRONMENTS.includes(environment),

  environment,

  integrations: [Sentry.replayIntegration()],

  // Performance: sample 10% of page loads / navigations. 100% was burning the
  // whole performance quota in a few days.
  tracesSampleRate: 0.1,

  // Session Replay: do not record normal sessions, only a share of sessions
  // that hit an error. The plan only includes 500 replays per month.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.25,

  // Errors that are caused by the user's network, browser or extensions and
  // that we cannot act on. Each of these was a top issue in Sentry.
  ignoreErrors: [
    // next-pwa service worker registration / update noise
    'Error: Rejected',
    /^Rejected$/,
    /Failed to register a ServiceWorker/i,
    /Response served by service worker is an error/i,
    /Failed to execute 'add' on 'Cache'/i,
    // Network failures on the user's side
    'Network Error',
    'AxiosError: Network Error',
    /Failed to fetch/i,
    /NetworkError when attempting to fetch resource/i,
    /Load failed/i,
    'NS_ERROR_FAILURE',
    'NS_ERROR_ABORT',
    // Next.js chunk loading after a deploy
    /ChunkLoadError/i,
    /Loading chunk [\d]+ failed/i,
    /Failed to load static props/i,
    // Browser extensions / wallets injected into the page
    /MetaMask/i,
    /tabId not found/i,
    /Java object is gone/i,
    // Common browser noise
    /ResizeObserver loop/i,
    /Non-Error promise rejection captured/i,
    /SecurityError: Failed to read the 'localStorage' property/i,
  ],

  // Do not report errors thrown from browser extensions or third-party scripts.
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-extension:\/\//i,
    /injected-scripts/i,
    /inpage\.js/i,
  ],

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});
